import React, { LazyExoticComponent, lazy, Suspense } from "react";
import { Route as ReactRoute, Redirect } from "react-router-dom";

import { IRouteProps, IWaitingProps } from "./types";

export const Route: React.FC<IRouteProps> = ({ loadChildren, loadingComponent,
    middleware, ...rest }: IRouteProps) => {

    const extraProps: IRouteProps = {};
    let lazyComponent: LazyExoticComponent<any> | undefined;
    if (loadChildren) lazyComponent = lazy(loadChildren);
    if (lazyComponent) extraProps.component = waitingComponent({ component: lazyComponent, loading: loadingComponent });

    const IRouteProps: IRouteProps = { ...rest, ...extraProps };
    if (IRouteProps.component && middleware) {
        IRouteProps.render = middleware({ component: IRouteProps.component, redirect: Redirect });
        IRouteProps.component = undefined;
    }

    return <ReactRoute {...IRouteProps} />;
};

export const waitingComponent = ({ component: Component, loading: Loading }: IWaitingProps) => (props: any) =>
    <Suspense fallback={Loading ? <Loading /> : null}>
        <Component {...props} />
    </Suspense>;
